import { Component, ElementRef, ViewChild } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { NotificationService } from '../notifications/notifications.service';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'topnav',
    templateUrl: 'topnav.html'
})
export class TopNavComponent {
    userData: any;
    username: string;
    controlName: any = [];
    adminData: any = [];
    count: number = 0;
    notifications: any = [];
    openNotifications = false;
    types:any = [{ name:'All', key:'all' }, { name: 'Read', key: 'read' }, { name:'Unread', key: 'unread' }];
    selectedType = 'all';
    notificationType = '';
    notificationTypes:any = [];
    @ViewChild('notificationsRef') notificationsRef: ElementRef;
    @ViewChild('notificationsIconRef') notificationsIconRef: ElementRef;

    constructor(public service: DashboardService, private apiCall: NotificationService, private _elementRef: ElementRef){
        // document.addEventListener('click', this.offClickHandler.bind(this)); // bind on doc
    }

    ngOnInit(){  
        this.userData = JSON.parse(localStorage.getItem('token'));
        this.username = this.userData.principal.firstname;
        this.adminData = this.userData.principal.roles;
        this.controlName = this.userData.principal.controlGroups.length > 1 ? "" : this.userData.principal.controlGroups[0];
        // this.getnotifications();
    
    }
    // offClickHandler(e:any) {
    //     if (!this.notificationsRef.nativeElement.contains(e.target) && !this.notificationsIconRef.nativeElement.contains(e.target)) { // check click origin
    //         this.openNotifications = false;
    //     }
    // }
     
    // readNotifications(id:any, read:any){
    //     this.apiCall.readNotifications(id, !read).subscribe((res: any) => {
    //     this.getnotifications();
    //     })
    // }
    // getnotifications(){
    //     const data = this.filterData(true, false, this.selectedType);
    //     this.apiCall.getNotifications(data).subscribe((res: any) => {
    //         this.notifications = res.notifications;
    //         this.count = res.unreadNotificationCount;
    //         this.notificationTypes = res.notificationTypes;
    //     })
    // }
    onLogout(){
        localStorage.removeItem('token')
    }

    // toggleNotifications(){
    //     return this.openNotifications ? {'width': '430px', 'backgroundColor': '#FFF'} : {'width': 0, 'backgroundColor': 'white'}
    // }

    // markNotifications(value:any){
    //     const data = this.filterData(false, value);
    //     this.apiCall.markNotifications(data).subscribe((res: any) => {
    //             this.notifications = res;
    //             this.getnotifications();
    //     })
    // }

    // getUnread(type:any){
    //     this.selectedType = type.key;
    //     this.getnotifications();
    // }

    // filterData(pagination:any, readAll:any, status = 'all', taxYear:any = []){
    //     return  {
    //         controlGroup: this.userData.principal.roles[0] == 'User' ? this.userData.principal.controlGroups : [], 
    //         taxYear, 
    //         status,
    //         userId: this.userData.principal.user_id,
    //         notificationTyps: this.notificationType ? [this.notificationType] : [],
    //         pagination: pagination ? {
    //             pageNo: 1,
    //             pageSize: 10
    //           }: undefined,
    //         readAll
    //     }
    // }
    // getFilterData(){
    //     localStorage.setItem('notificationTyps', this.notificationType);
    //     this.getnotifications(); 
    // }
}



// WEBPACK FOOTER //
// ./src/app/layout/topnav.component.ts